import Repository from '../axios'
import { defaultPagination } from "../constants/config";

export default {
    getListGrni(pageNumber = 1, pagination = defaultPagination, from = '', to = '', order_type = '', payment_status = '', search = '', sort = '') {
        return Repository.get(`/admin/report/grni-statistics?paginate=${pagination}&page=${pageNumber}&from=${from}&to=${to}&order-type=${order_type}&payment-status=${payment_status}&filter[search]=${search}&sort=${sort}`)
    },
};